import React, { useContext } from 'react'
import Button, { ButtonProps } from '../Button'
import { FormContext } from './FormContext'

export type SubmitProps = ButtonProps & {
  label: string
}

const style = {
  textAlign: 'right'
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Submit: React.FC<SubmitProps> = ({ label, ref, ...props }) => {
  const { scope } = useContext(FormContext)
  const name = scope && props.name ? `${scope}[${props.name}]` : props.name

  return (
    <div className={['form-input-submit', props.className].filter((x) => !!x).join(' ')} style={style}>
      <Button {...props} cta={true} name={name}>
        {label}
      </Button>
    </div>
  )
}

export default Submit
